const en = {
  common: {
    ok: "OK!",
    cancel: "Cancel",
    back: "Back",
  },
  welcomeScreen: {
    readyForLaunch: "Ready for launch",
    exciting: "It's exciting!",
  },
  errorScreen: {
    title: "Something went wrong",
    friendlySubtitle: "We're sorry for the inconvenience. Please try restarting the app.",
    contactSupport: "Contact Support",
    reset: "RESTART APP",
  },
  emptyStateComponent: {
    generic: {
      heading: "So empty... so sad",
      content: "No data found yet. Try clicking the button to refresh or reload the app.",
      button: "Let's try this again",
    },
  },
}

export default en
export type Translations = typeof en
